import Vue from 'vue'
import moment from 'moment'
Vue.filter('money', function (value, { currency }) {
    if (isNaN(value)) {
        return 0
    }
    if (currency) {
        switch (currency.toLowerCase()) {
            case 'vnd':
                return new Intl.NumberFormat().format(value) + ' VND'
            case 'dolar':
                return '$' + new Intl.NumberFormat(undefined, { currency: 'EUR' }).format(value)
        }
    }
    return new Intl.NumberFormat().format(value)
})

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(value).format('MMM D,YYYY')
    }
    return ''
})

Vue.filter('formatDateTime', function (value) {
    if (value) {
        return moment(value).format('LL')
    }
    return ''
})

Vue.filter('abs', function (value) {
    if (value) {
        return Math.abs(value)
    }
    return ''
})

